import { ReactComponent as ArrowSort } from "./assets/arrow_sort.svg";
import { useNavigate, useParams } from "react-router-dom";
import GoBackButton from "../../components/GoBackButton";
import ReleasesList from "../../components/ReleasesList";
import PodcastDetailInfo from "../../components/PodcastDetailInfo";
import {
  PodcastImage,
  PodcastDetailWrapper,
  PodcastDetailPageContainer,
  ReleasesListWrapper,
  PodcastDetailWrapperSkeleton,
  ReleasesListWrapperSkeleton,
  SortButton,
  ArrowContainer,
} from "./styled";
import Skeleton from "react-loading-skeleton";
import NothingFound from "../../components/NothingFound";
import { useGetPodcastsQuery } from "../../api/podcastsApi";
import PageContainer from "../../components/PageContainer";
import { useMemo, useState } from "react";
import { useMetaTags } from "../../hooks/useMetaTags";

import ReleasePodcastInfo from "../../components/SideMenu/ReleasePodcastInfo/ReleasePodcastInfo";
import { useDispatch } from "react-redux";
import { setReleasePodcastInfo } from "../../redux/Slice/releasePodcastSlice";
import { enableBlackout } from "../../redux/Slice/modalSlice";
import { Dialog } from "../../components/Dialog";

export const PodcastDetailPage = () => {
  const { podcastLink, podcastItemId } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    data: podcast,
    isError: isPodcastError,
    isLoading: isPodcastLoading,
  } = useGetPodcastsQuery({ link: podcastLink });

  const [sortOrder, setSortOrder] = useState("newest");

  const sortedPodcast = useMemo(() => {
    if (!podcast) return null;

    return {
      ...podcast,
      podcastReleases: podcast.podcastReleases
        ? [...podcast.podcastReleases].sort((a, b) => {
            const dateA = new Date(a.publishedAt).getTime();
            const dateB = new Date(b.publishedAt).getTime();
            return sortOrder === "newest" ? dateB - dateA : dateA - dateB;
          })
        : [],
    };
  }, [podcast, sortOrder]);

  const handleReleasesSort = () => {
    setSortOrder((prev) => (prev === "newest" ? "oldest" : "newest"));
  };

  const metaData = useMemo(() => {
    if (!podcast?.podcastReleases || !podcastItemId) {
      return;
    }

    if (podcastItemId) {
      return {
        metaTitle: podcast.podcastReleases.find(
          (item) => item.trackLink === podcastItemId,
        )?.metadata?.title,
        metaDescription: podcast.podcastReleases.find(
          (item) => item.trackLink === podcastItemId,
        )?.metadata?.description,
      };
    }
  }, [podcast?.podcastReleases, podcastItemId]);

  useMetaTags(metaData);

  const handleClickCardRelease = (release) => {
    dispatch(setReleasePodcastInfo(release));

    dispatch(enableBlackout());
    navigate(release.trackLink, { replace: true });
  };

  const handleCloseModal = () => {
    navigate(`/podcasts/${podcastLink}`, { replace: true });
  };

  if (isPodcastError) {
    return <NothingFound />;
  }

  return (
    <PodcastDetailPageContainer as={PageContainer}>
      <GoBackButton to="/podcasts" />
      {isPodcastLoading ? (
        <PodcastDetailWrapperSkeleton as={Skeleton} />
      ) : (
        <PodcastDetailWrapper>
          <PodcastImage src={podcast?.cover.big} alt={podcast?.title} />
          <PodcastDetailInfo podcast={podcast ?? {}} />
        </PodcastDetailWrapper>
      )}
      {isPodcastLoading ? (
        <ReleasesListWrapperSkeleton as={Skeleton} count={4} />
      ) : (
        <ReleasesListWrapper>
          <SortButton onClick={handleReleasesSort}>
            {sortOrder === "newest" ? "Сначала новые" : "Сначала старые"}
            <ArrowContainer sortOrder={sortOrder}>
              <ArrowSort />
            </ArrowContainer>
          </SortButton>

          <ReleasesList
            releases={sortedPodcast.podcastReleases ?? []}
            releasesPodcast={sortedPodcast ?? {}}
            isLoading={isPodcastLoading}
            onClickCardRelease={handleClickCardRelease}
            inPodcast
          />
        </ReleasesListWrapper>
      )}
      <Dialog
        openingDirection="onRight"
        title="О выпуске"
        showBlackout
        isOpen={!!podcastItemId}
        onClose={handleCloseModal}
        modalName=""
      >
        <ReleasePodcastInfo
          release={
            podcastItemId &&
            podcast?.podcastReleases.find(
              (item) => item.trackLink === podcastItemId,
            )
          }
        />
      </Dialog>
    </PodcastDetailPageContainer>
  );
};
